import { render, staticRenderFns } from "./ApplyMsg.vue?vue&type=template&id=281aef6b&scoped=true&"
import script from "./ApplyMsg.vue?vue&type=script&lang=js&"
export * from "./ApplyMsg.vue?vue&type=script&lang=js&"
import style0 from "./ApplyMsg.vue?vue&type=style&index=0&id=281aef6b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281aef6b",
  null
  
)

export default component.exports